import { type InsuranceCorporateIdentity } from "../types";

export function BBraunAesculapLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_36_10305)">
        <path
          d="M320.176 80C409.178 80 412.601 157.103 412.601 157.103C412.601 237.634 344.138 235.92 344.138 235.92C443.409 235.92 439.986 328.444 439.986 328.444C439.986 438.102 308.196 432.962 308.196 432.962H72C72 432.962 99.385 426.109 99.385 400.407V114.268C99.385 88.567 73.7116 80 73.7116 80H320.176ZM210.637 139.969V369.566H277.387C277.387 369.566 335.581 369.566 332.157 319.877C332.157 319.877 332.157 278.755 224.329 232.493H267.118C267.118 232.493 313.33 234.207 313.33 184.518C313.33 138.256 263.695 138.256 263.695 138.256L210.637 139.969Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_36_10305">
          <rect
            width="368"
            height="353"
            fill="white"
            transform="translate(72 80)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export const BBraunAesculap: InsuranceCorporateIdentity = {
  id: "b-braun-aesculap",
  name: "B. Braun Aesculap",
  logo: BBraunAesculapLogo,
  backgroundColor: "#00A97A",
  textColor: "#FFFFFF",
  wildcard: { or: ["aesculap", "braun"] },
  type: "statutory",
};
